<template>
  <div id="square">
  <createIndex></createIndex>
    <div class="tab flex ">
      <div class="item"
           :class="index==tab_active?'active':''"
           v-for="(item,index) in tab_list"
           :key="index">{{ item }}
      </div>
    </div>
    <!--    <div class="search">-->
    <!--      <el-input placeholder="请输入关键词"-->
    <!--                class="keywords"-->
    <!--                size="small"-->
    <!--                prefix-icon="el-icon-search"-->
    <!--                v-model="keywords"-->
    <!--                @keyup.enter="search">-->
    <!--      </el-input>-->
    <!--    </div>-->
    <div class="tags" flex-align>
      <div :class="item.tj_cate_id==tag_active?'active':''"
           @click="choose_tag(index)"
           v-for="(item,index) in tag_list"
           :key="index">{{ item.name }}
      </div>
    </div>
    <div class="tab_con">
      <div class="tab_draw"
           v-if="water_draw_list.length">
        <waterfall ref="waterfall"
                   :col="2"
                   :width="fall_width"
                   :gutterWidth="5"
                   :data="water_draw_list"
                   @loadmore="loadmore_draw"
                   :height="'100%'">
          <template>
            <div class="cell_item"
                 @click="showVideo(item,index)"
                 v-for="(item, index) in water_draw_list"
                 :key="index">
              <video :src="item.video_url" class="pic" controlslist="nodownload"
                     :poster="item.cover_url!=null?item.cover_url:''" style=""
                     :preload="item.cover_url!=null?'none':'auto'" v-loading="true"
              >
              </video>
            </div>
          </template>
        </waterfall>
      </div>
      <empty v-else></empty>
    </div>

    <el-dialog :visible.sync="videoDialogVisible" @closed="dialogClose" @clos="dialogClose"
               custom-class="is-align-center csd-dialog un-border" width="300px" :modal="false"
               :show-close="false" :close-on-press-escape="false">
      <div class="video_dialog">
        <div class="dialog_close"><i class="el-icon-close" @click="videoDialogVisible=false"></i></div>
        <div class="dialog_title">作品详情</div>
        <div class="video_wrap" flex-center>
          <video ref="dialogVideo" width="300px" height="200px" :src="select_video.video_url" controls
                 controlslist="nodownload"></video>
        </div>
        <div class="opt_line jb" flex-align>
          <div class="line_left" flex-align>
            {{ select_video.text_prompt==null || select_video.text_prompt=='' ?'':'视频描述'  }}
            <div class="" style="display: flex;align-items: center;margin-left: 5px">
              <svg style="display: block" width="20" t="1731061781933" class="icon" viewBox="0 0 1024 1024"
                   version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4266">
                <path
                    d="M190.193225 471.411583c14.446014 0 26.139334-11.718903 26.139334-26.13831 0-14.44499-11.69332-26.164916-26.139334-26.164916-0.271176 0-0.490164 0.149403-0.73678 0.149403l-62.496379 0.146333c-1.425466-0.195451-2.90005-0.295735-4.373611-0.295735-19.677155 0-35.621289 16.141632-35.621289 36.114522L86.622358 888.550075c0 19.949354 15.96767 35.597753 35.670407 35.597753 1.916653 0 3.808746 0.292666 5.649674 0l61.022819 0.022513c0.099261 0 0.148379 0.048095 0.24764 0.048095 0.097214 0 0.146333-0.048095 0.24457-0.048095l0.73678 0 0-0.148379c13.413498-0.540306 24.174586-11.422144 24.174586-24.960485 0-13.55983-10.760065-24.441669-24.174586-24.981974l0-0.393973-50.949392 0 1.450025-402.275993L190.193225 471.409536z"
                    fill="#5D5D5D" p-id="4267"></path>
                <path
                    d="M926.52241 433.948343c-19.283182-31.445176-47.339168-44.172035-81.289398-45.546336-1.77032-0.246617-3.536546-0.39295-5.380544-0.39295l-205.447139-0.688685c13.462616-39.059598 22.698978-85.58933 22.698978-129.317251 0-28.349675-3.193739-55.962569-9.041934-82.542948l-0.490164 0.049119c-10.638291-46.578852-51.736315-81.31498-100.966553-81.31498-57.264215 0-95.466282 48.15065-95.466282 106.126063 0 3.241834-0.294712 6.387477 0 9.532097-2.996241 108.386546-91.240027 195.548698-196.23636 207.513194l0 54.881958-0.785899 222.227314 0 229.744521 10.709923 0 500.025271 0.222057 8.746198-0.243547c19.35686 0.049119 30.239721-4.817726 47.803749-16.116049 16.682961-10.761088 29.236881-25.50079 37.490869-42.156122 2.260483-3.341095 4.028757-7.075139 5.106298-11.20111l77.018118-344.324116c1.056052-4.053316 1.348718-8.181333 1.056052-12.160971C943.643346 476.446249 938.781618 453.944769 926.52241 433.948343zM893.82573 486.837924l-82.983993 367.783411-0.099261-0.049119c-2.555196 6.141884-6.879688 11.596106-12.872169 15.427364-4.177136 2.727111-8.773827 4.351098-13.414521 4.964058-1.49812-0.195451-3.046383 0-4.620227 0l-477.028511-0.540306-0.171915-407.408897c89.323375-40.266076 154.841577-79.670527 188.596356-173.661202 0.072655 0.024559 0.124843 0.049119 0.195451 0.072655 2.99931-9.137101 6.313799-20.73423 8.697079-33.164331 5.551436-29.185716 5.258771-58.123792 5.258771-58.123792-4.937452-37.98001 25.940812-52.965306 44.364417-52.965306 25.304316 0.860601 50.263777 33.656541 50.263777 52.326762 0 0 5.600555 27.563776 5.649674 57.190537 0.048095 37.366026-4.6673 56.847729-4.6673 56.847729l-0.466628 0c-5.872754 30.879288-16.214287 60.138682-30.464849 86.964654l0.36839 0.342808c-2.358721 4.815679-3.709485 10.220782-3.709485 15.943111 0 19.922748 19.088754 21.742187 38.765909 21.742187l238.761895 0.270153c0 0 14.666024 0.465604 14.690584 0.465604l0 0.100284c12.132318-0.638543 24.221658 5.207605 31.100322 16.409738 5.504364 9.016351 6.437619 19.6045 3.486404 28.988218L893.82573 486.837924z"
                    fill="#5D5D5D" p-id="4268"></path>
                <path
                    d="M264.827039 924.31872c0.319272 0.024559 0.441045 0.024559 0.295735-0.024559 0.243547-0.048095 0.367367-0.074701-0.295735-0.074701s-0.539282 0.026606-0.271176 0.074701C264.43409 924.343279 264.532327 924.343279 264.827039 924.31872z"
                    fill="#5D5D5D" p-id="4269"></path>
              </svg>

              <span style="margin-left: 3px;">
{{ select_video.votes }}
              </span>
            </div>
            <div class="" style="display: flex;align-items: center;margin-left: 5px">
              <svg style="display: block;" width="20" t="1731064340593" class="icon" viewBox="0 0 1024 1024"
                   version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5264">
                <path
                    d="M511.872 286.62784c55.86944 0 114.36544 13.20448 173.8752 39.2448 48.93184 21.41696 98.61632 51.47136 147.66592 89.33888 50.93376 39.32672 90.71104 79.10912 114.5088 104.8064-23.45472 25.34912-62.4896 64.39936-112.83968 103.47008-49.2288 38.1952-99.11808 68.52608-148.26496 90.15808-59.88352 26.35264-118.74304 39.71584-174.94528 39.71584-55.86432 0-114.36032-13.20448-173.87008-39.24992-48.93696-21.41696-98.61632-51.47136-147.66592-89.33888-50.93376-39.3216-90.71104-79.104-114.51392-104.8064 23.45472-25.344 62.49472-64.39424 112.84992-103.46496 49.23392-38.1952 99.11296-68.53632 148.26496-90.1632C396.81024 299.99104 455.67488 286.62784 511.872 286.62784L511.872 286.62784zM511.872 241.14688C237.65504 241.14688 15.36 519.99744 15.36 519.99744s222.29504 278.85568 496.512 278.85568c274.21696 0 496.512-278.85568 496.512-278.85568S786.08896 241.14688 511.872 241.14688L511.872 241.14688M511.104 413.30176c55.80288 0 101.20192 45.39904 101.20192 101.20192 0 55.79776-45.39392 101.1968-101.20192 101.1968-55.79776 0-101.1968-45.39904-101.1968-101.1968C409.9072 458.7008 455.30624 413.30176 511.104 413.30176L511.104 413.30176zM511.104 367.81568c-81.00864 0-146.67776 65.66912-146.67776 146.68288 0 81.00864 65.66912 146.67776 146.67776 146.67776s146.68288-65.66912 146.68288-146.67776C657.792 433.49504 592.11264 367.81568 511.104 367.81568L511.104 367.81568"
                    fill="#bfbfbf" p-id="5265"></path>
              </svg>

              <span style="margin-left: 3px;">
                {{ select_video.views }}</span>
            </div>
          </div>
          <div class="line_right">
            <div class="right_btn" v-if="useGood" @click="good_video()">已点赞</div>
            <div class="right_btn" v-if="!useGood" @click="good_video()">点赞</div>
            <div class="right_btn" @click="downloadVideo(select_video,)">下载</div>
          </div>

        </div>
        <div class="video_desc">{{ select_video.text_prompt }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import empty from '@/components/Empty'
import createIndex from "@/components/createIndex"
import utils from "@/utils";

export default {
  components: {empty,createIndex},
  data() {
    return {
      tab_list: ['视频广场'],
      tab_active: 0,
      fall_width: 120,
      keywords: '',
      tag_active: 0,
      tag_list: [{
        tj_cate_id: '0',
        name: '精选推荐'
      }, {
        tj_cate_id: '1',
        name: '热门排行'
      }, {
        tj_cate_id: '2',
        name: '最新发布'
      },],
      water_draw_list: [],
      page: 1,
      water_video_list: [],
      max_mj_id: 0,

      // 视频弹窗
      videoDialogVisible: false,
      select_video: {},
      useGood: false,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },

  },
  created() {
    document.onkeyup = e => {
      if (e.keyCode === 13) {
        // 调用登录 验证方法
        this.search()
      }
    }
    // 屏幕宽度
    let screenWidth = document.documentElement.clientWidth;
    this.fall_width = (screenWidth - 30) / 2;

    this.get_draw_list()
  },
  methods: {
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
          this.videoDialogVisible = false;
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },
    //选择标签
    choose_tag(index) {
      this.water_draw_list = []
      this.page = 1
      this.tag_active = index;
      this.noMore = false;
      this.get_draw_list()
    },
    search() {
      this.water_draw_list = []
      this.page = 1;
      this.max_mj_id = 0;
      this.cate_id = 0;
      this.get_draw_list();
    },
    //获取绘画广场数据
    get_draw_list() {
      this.loading = true;

      this.$http.get(`/front/aivideo/index/?page_size=20&page=${this.page}&sort=${this.tag_list[this.tag_active].tj_cate_id}`, {params: {keywords: this.keywords}}).then(res => {
        if (res.status == '200') {
          if (res.data.item_list.length < 20) {
            // this.$message('没有更多了');
            this.noMore = true;
          }
          this.water_draw_list = this.water_draw_list.concat(res.data.item_list);
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //绘画广场加载更多
    loadmore_draw() {
      this.page++;
      this.get_draw_list()
    },
    // go(item) {
    //   this.$router.push('/drawDetail?draw_id=' + item.id)
    // }
    showVideo(item, index) {
      this.select_video = item;
      this.select_video.is_goods = 0;
      this.video_num = index;
      this.videoDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.dialogVideo.play()
      })
      if (this.isLogin) {
        this.$http.get(`/front/aivideo/votes/${item.id}/?soft=1`,).then(res => {
          if (res.status == '200') {
            this.useGood = res.data.is_vote;
          }
        }).finally(() => {
          this.loading = false
        })
      }

    },
    dialogClose() {
      this.select_video = {};
      this.useGood = false;
      this.$refs.dialogVideo.pause()
    },
    //点赞浏览
    good_video() {
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
          this.videoDialogVisible = false;
        })
        return false
      }
      this.$http.get(`/front/aivideo/votes/${this.select_video.id}/?soft=2`,).then(res => {
        if (res.status == '200') {
          // this.water_draw_list[this.video_num].is_goods = 1;
          if (res.data.is_vote == 1){
            this.select_video.votes++
            this.useGood = true;
            this.$message({
              showClose: true,
              message: '点赞成功',
              type: 'success'
            });
          }else{
            this.select_video.votes--
            this.useGood = false;
            this.$message({
              showClose: true,
              message: '已取消点赞',
              type: 'success'
            });
          }

        }
      }).finally(() => {
        this.loading = false
      })
    },
    downloadVideo(is_video, ) {
      // return
      if (!this.checkLogin()) {
        return
      }
      // if (this.userInfo.is_vip < 1) {
      //   this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$router.push('/member')
      //   })
      //   return false
      // }

      this.$http.get(`/front/aivideo/download/${is_video.id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        }else{
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(err=>{
        let message = err.message;
        utils.createErrTip(message)
      }).finally(() => {
        this.loading = false
      })

    },

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#square {
  width: 100%;
  height: 100%;
  padding: 10px 10px 55px;
  // display: flex;
  // flex-direction: column;
  overflow-y: auto;
}

.tab {
  justify-content: center;
  margin: 10px 0 20px;

  .item {
    cursor: pointer;
    font-size: 22px;
    font-weight: bold;
    color: #949ba4;
    margin: 0 50px;
    position: relative;
    height: 35px;
    line-height: 35px;

    &.active {
      font-size: 26px;
      color: #fff;

      &:after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: "";
        width: 100%;
        height: 5px;
        background: linear-gradient(
                90deg,
                #5865f2 0%,
                rgba(88, 101, 242, 0) 99%
        );
      }
    }
  }
}

.search {
  width: 100%;
  margin: 0 auto 20px;

  .keywords {
    border: 2px solid #5865f2;
    background-color: transparent;
    border-radius: 30px;

    /deep/ .el-input__inner {
      background-color: transparent;
      border: none;
      color: rgba(255, 255, 255, 0.78);
    }
  }
}

.tags {
  margin-bottom: 15px;
  justify-content: center;
  overflow-x: auto;
  padding-bottom: 5px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    margin-left: 5px !important;
    display: block !important;
    height: 6px !important;
  }

  &::-webkit-scrollbar-thumb {
    height: 30px !important;
    background-color: #777 !important;
    border-radius: 10px !important;
  }

  div {
    cursor: pointer;
    font-size: 14px;
    color: #d8d9db;
    margin-right: 10px;
    padding: 0 16px;
    height: 26px;
    line-height: 26px;
    white-space: nowrap;

    &.active {
      background: #474e53;
      border-radius: 30px;
    }
  }
}

.tab_con {
  overflow: hidden;
  flex: 1;
}


.tab_draw {
  //overflow: hidden;
  //height: 100%;
  //margin: 10px 0;
  //width: 80%;
  overflow: hidden;
  overflow-y: scroll;
  height: 100%;
  display: flex;
  justify-content: center;

  .cell_item {
    //width: 50px;
    position: relative;
    width: 100%; /* 或者具体宽度值，例如：500px; */
    overflow: hidden;
    border-radius: 10px;
    margin-bottom: 10px;

    .pic {
      width: 100%;
      height: 100%;
    }

  }

}
.video_dialog {
  background-color: #1d1e23;
  width: 300px;
  padding: 15px;
  color: #fff;
  position: relative;
  cursor: pointer;
  z-index: 2010;

  .dialog_close {
    position: absolute;
    top: 10px;
    right: 15px;
    color: #707072;
    padding: 5px;
    font-size: 18px;
  }

  .dialog_title {
    font-weight: 700;
    font-size: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #343539;
  }

  .video_wrap {
    margin: 15px 0;
    background-color: #111;

    video {
      width: 270px;
      //height: 225px;
    }
  }

  .opt_line {
    margin: 15px 0;
    color: #fff;

    .line_left {
      .el-icon-document-copy {
        font-size: 14px;
        margin-left: 15px;
        color: #6c6c6d;
        cursor: pointer;

        &:hover {
          color: #9DABBD;
        }
      }
    }

    .line_right {
      display: flex;

      .right_btn {
        font-size: 12px;
        cursor: pointer;
        background-color: transparent;
        color: #5865f2;
        border: 1px solid #5865f2;
        border-radius: 1000px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        white-space: nowrap;
        user-select: none;
        width: 50px;
        height: 25px;
        margin-left: 10px;

        &:hover {
          color: rgba(88, 101, 242, .667);
          border: 1px solid rgba(88, 101, 242, .6666666667);
        }
      }
    }

  }
  .video_desc {
    word-break: break-all;
    white-space: normal;
    line-height: 16px;
    color: #9DABBD;
  }

}
</style>